import { dateFromString } from '@retail/utils';
import { CalculusConditionDTO } from '../../dtos';
import { ConditionBaseProps, ItemConditionBase } from '../ConditionBase';
import { SupplierBase } from '@retail/suppliers/types';

interface CustomerMarkupConditionProps extends ConditionBaseProps<CustomerMarkupCondition> {
  coverageDegree?: number;
  markupCoverageDegree?: number;
  markupSalesFactor?: number;
}

export class CustomerMarkupCondition extends ItemConditionBase<CustomerMarkupCondition> {
  coverageDegree?: number;
  markupCoverageDegree?: number;
  markupSalesFactor?: number;

  constructor({
    coverageDegree,
    markupCoverageDegree,
    markupSalesFactor,
    ...superProps
  }: CustomerMarkupConditionProps) {
    super(superProps);
    this.coverageDegree = coverageDegree;
    this.markupCoverageDegree = markupCoverageDegree;
    this.markupSalesFactor = markupSalesFactor;
  }

  static fromDto = (dto: CalculusConditionDTO): CustomerMarkupCondition =>
    new CustomerMarkupCondition({
      id: dto.id,
      assortmentId: dto.assortmentId,
      assortmentName: dto.assortmentName,
      inDraft: dto.inDraft,
      type: dto.type,
      supplier: dto.supplier ? SupplierBase.fromDto(dto.supplier) : undefined,
      bindingType: dto.bindingType,
      bindingTarget: dto.bindingTarget,
      bindingTargetName: dto.bindingTargetName,
      bindingTargetId: dto.bindingTargetId,
      bindingTargetItem: dto.bindingTargetItem,
      validFrom: new Date(dto.validFrom),
      validTo: dateFromString(dto.validTo),
      coverageDegree: dto.coverageDegree,
      markupCoverageDegree: dto.markupCoverageDegree,
      markupSalesFactor: dto.markupSalesFactor,
    });
}
